import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Button } from "@mantine/core";
import { toast } from "react-toastify";

import { getRuleExportSavedData } from "../../../../services/rules";

const ExportSavedDataButton = ({ id, name, hasSavedData }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const exportMutation = useMutation({
    mutationFn: () => getRuleExportSavedData(id),
    onSuccess: (data) => {
      const blob = data instanceof Blob ? data : new Blob([data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${id}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`Downloaded: ${name} ID: ${id}`);
    },
    onError: (error) => {
      const errorBody = error?.response?.data;
      if (errorBody?.text) {
        errorBody.text().then((text) => {
          try {
            const errorInfo = JSON.parse(text);
            toast.error(`Failed to download: ${errorInfo?.message}`);
          } catch {
            toast.error("Failed to download");
          }
        });
      } else {
        toast.error("Failed to download");
      }
    },
  });

  const handleClick = async () => {
    try {
      setIsDownloading(true);
      await exportMutation.mutateAsync();
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      variant="subtle"
      size="xs"
      disabled={!hasSavedData || isDownloading || exportMutation.isPending}
      onClick={handleClick}
    >
      {isDownloading ? "Loading..." : "Download"}
    </Button>
  );
};

export default ExportSavedDataButton;
